import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  locationloading: false,
  loadingCompany: false,
  loadingSkills: false,
  skillListings: [],
  error: {},
  errorSuggestion: {},
  searchvalue: "",
  filters: [],
  searchSuggestions: [],
  locations: [],
  citySuggestions: [],
  regionSuggestions: [],
  stateSuggestions: [],
  isSuccess: false,
  skillListingCount: [],
  countLoading: false,
  totalCountLoading: false,
  skillListingTotalCount: [],
  companies:[],
  industries:[],
  skills:[],
  searchIconClicked:false
};

const searchSkillListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_LISTING_INIT:
      return {
        ...state,
        loading: action.payload,
        isSuccess: false,
      };
    case types.SEARCH_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        skillListings: {
          ...state.skillListings,
          skillListings: action.payload,
        },
        error: {},
        isSuccess: true,
      };
    case types.SEARCH_LISTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    //SKILL_LISTING COUNT
    case types.SKILL_LISTING_COUNT_INIT:
      return {
        ...state,
        countLoading: true,
      };
    case types.SKILL_LISTING_COUNT_SUCCESS:
      return {
        ...state,
        countLoading: false,
        skillListingCount: action.payload,
        error: {},
      };
    case types.SKILL_LISTING_COUNT_FAILURE:
      return {
        ...state,
        countLoading: false,
        error: action.error,
        skillListingCount: {},
      };

    // skilllisting total count
    case types.SKILL_LISTING_TOTALCOUNT_INIT:
      return {
        ...state,
        totalCountLoading: true,
      };
    case types.SKILL_LISTING_TOTALCOUNT_SUCCESS:
      return {
        ...state,
        totalCountLoading: false,
        skillListingTotalCount: action.payload,
        error: {},
      };
    case types.SKILL_LISTING_TOTALCOUNT_FAILURE:
      return {
        ...state,
        totalCountLoading: false,
        error: action.error,
        skillListingTotalCount: {},
      };
    // /////////////////////////////////////
    case types.SEARCH_VALUE:
      return {
        ...state,
        searchvalue: action.payload,
      };

    case types.SEARCH_TYPE:
      return {
        ...state,
        searchtype: action.payload,
      };

//searchIconClicked
case types.SEARCH_ICON_CLICKED:
  return {
    ...state,
    searchIconClicked: action.payload,
  };
//c;ear search icon clicked
case types.CLEAR_SEARCH_ICON_CLICKED:

  return {
    ...state,
    searchIconClicked: false,
  };

    case types.GET_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };
    case types.FETCH_SEARCH_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchSuggestions: {
          ...state.searchSuggestions,
          searchSuggestions: action.payload,
        },
        error: {},
      };
    case types.FETCH_SEARCH_SUGGESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        errorSuggestion: action.error,
      };
    case types.FETCH_SEARCH_LOCATION_SUCCESS:
      return {
        ...state,
        locations: action.payload,
      };

    //region
    case types.FETCH_REGION_SUGGESTIONS_INIT:
      return {
        ...state,
        regionSuggestions: action.payload,
      };

    case types.FETCH_REGION_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        regionSuggestions: action.payload,
      };
    //state
    case types.FETCH_STATE_SUGGESTIONS_INIT:
      return {
        ...state,
        stateSuggestions: action.payload,
      };

    case types.FETCH_STATE_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        stateSuggestions: action.payload,
      };

    case types.CLEAR_SEARCH_SUGGESTIONS_REQUESTED:
      return {
        ...state,
        searchSuggestions: [],
      };

    // new
    case types.FETCH_SEARCH_DYNAMIC_LOCATION_INIT:
      return {
        ...state,
        locationloading: true,
        isSuccess: false,
      };
    case types.FETCH_SEARCH_DYNAMIC_LOCATION_SUCCESS:
      const value = action.payload?.value;
      const arr = action.payload.result.locationDetails?.countryCount;
      const type = value?.includes('location') ? 'location' : value?.includes('region') ? 'region': value?.includes('country') ? 'country': null;
      const Usa = 
      // type == null || value == 'country=' ? [{CountryId: 254, CountryName: "United States", _id: "United States"}, ...arr] : 
      action.payload.result.locationDetails?.countryCount;
      if(window.innerWidth < 768){
        return {
          ...state,
          locationloading: false,
          error: {},
          isSuccess: true,
          locations: (type != 'location') && action.payload.result.locationDetails?.citiesCount.length === 0 ? state.locations : action.payload.result.locationDetails?.citiesCount,
          stateSuggestions: (type != 'country') && action.payload.result.locationDetails?.countryCount.length === 0 ? state.stateSuggestions : action.payload.result.locationDetails?.countryCount,
          regionSuggestions: (type != 'region') && action.payload.result.locationDetails?.regionCount.length === 0 ? state.regionSuggestions : action.payload.result.locationDetails?.regionCount,
        };
      } else{
        return {
          ...state,
          locationloading: false,
          error: {},
          isSuccess: true,
          locations: (type === 'location' || !type) ? 
                      action.payload.result.locationDetails?.citiesCount.length > 0 ? 
                      action.payload.result.locationDetails?.citiesCount 
                      : [] 
                      : state.locations,
          stateSuggestions: (type === 'country' || type === 'location' || !type) ? 
                            action.payload.result.locationDetails?.countryCount.length > 0 ? 
                              action.payload.result.locationDetails?.countryCount 
                              : [] 
                              : state.stateSuggestions,
          regionSuggestions: (type === 'region' || type === 'location' || !type ) ? 
                            action.payload.result.locationDetails?.regionCount.length > 0 ? 
                                action.payload.result.locationDetails?.regionCount 
                                : [] 
                                : state.regionSuggestions,
        };
      }
    case types.FETCH_SEARCH_DYNAMIC_LOCATION_FAILURE:
      return {
        ...state,
        locationloading: false,
        isSuccess: false,
      };

    case types.FETCH_SEARCH_COMPANY_AND_INDUSTRIES_INIT:
      return {
        ...state,
        loadingCompany: true,
        isSuccess: false,
      };
    case types.FETCH_SEARCH_COMPANY_AND_INDUSTRIES_SUCCESS:
      return {
        ...state,
        loadingCompany: false,
        error: {},
        companies: action.payload,
        industries: action.payload,
      };
    case types.FETCH_SEARCH_COMPANY_AND_INDUSTRIES_FAILURE:
      return {
        ...state,
        loadingCompany: false,
        isSuccess: false,
      };

    case types.FETCH_SEARCH_SKILLS_INIT:
      return {
        ...state,
        loadingSkills: true,
        isSuccess: false,
      };
    case types.FETCH_SEARCH_SKILLS_SUCCESS:
      return {
        ...state,
        loadingSkills: false,
        error: {},
        skills: action.payload,
      };
    case types.FETCH_SEARCH_SKILLS_FAILURE:
      return {
        ...state,
        loadingSkills: false,
        isSuccess: false,
      };
    default:
      return state;
  }
};

export default searchSkillListingReducer;
